import React from 'react';
import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import LoadingSpinner from '@/components/UI/LoadingSpinner';

/**
 * Layout principal de la aplicación
 * Maneja la estructura general con sidebar, header y contenido
 */
const Layout: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem('itrio-sidebar-collapsed');
    return stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('itrio-sidebar-collapsed', String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Mostrar spinner mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirigir a login si no está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 app-layout">
      {/* Sidebar */}
      <Sidebar collapsed={isSidebarCollapsed} onToggleCollapsed={() => setIsSidebarCollapsed((current) => !current)} />

      {/* Contenido principal */}
      <div className={isSidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'}>
        {/* Header */}
        <Header />

        {/* Contenido de la página */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
